import React, { forwardRef } from "react";
import { DateRangePicker } from "@progress/kendo-react-dateinputs";

/**
 * DKNDateRangePicker — Daikin design system date range picker.
 * Wraps Kendo DateRangePicker.
 *
 * Props:
 *   value     { start: Date|null, end: Date|null }
 *   onChange  (e) => void  — e.value is { start, end }
 *   label     string
 *   error     string
 *   min       Date
 *   max       Date
 *   format    string (default: "dd.MM.yyyy")
 *   fullWidth boolean (default: false)
 *   disabled  boolean
 */
const DKNDateRangePicker = forwardRef(function DKNDateRangePicker(
  {
    value,
    onChange,
    label,
    error,
    min,
    max,
    format = "dd.MM.yyyy",
    fullWidth = false,
    disabled = false,
    className = "",
    style,
    ...rest
  },
  ref
) {
  return (
    <div
      className={`dkn-input-wrap${fullWidth ? " dkn-input-full" : ""}${error ? " dkn-input-error" : ""} ${className}`}
      style={style}
    >
      {label && <label className="dkn-input-label">{label}</label>}
      <DateRangePicker
        ref={ref}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        format={format}
        disabled={disabled}
        className={`dkn-input${error ? " dkn-input-invalid" : ""}`}
        {...rest}
      />
      {error && <span className="dkn-input-helper-text">{error}</span>}
    </div>
  );
});

export default DKNDateRangePicker;
